import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { AuthProvider } from './auth.jsx'
import { RbacProvider } from './lib/rbac.js'
import { ThemeProvider } from './lib/theme.jsx'
import { startClientErrorLog } from './lib/clientErrors.js'
import './styles.css'
import './tailwind.css'

// Keep the last few JavaScript errors this tab throws, so the Report issue
// button can send them along with the screenshot. In memory only, and they
// leave the browser only inside a report someone pressed a button to file.
startClientErrorLog()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <RbacProvider>
            <App />
          </RbacProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
